import React, { useState, useEffect } from 'react';
import { useApp } from '../../context/AppContext';
import api from '../../services/api';

const SectionsManager = () => {
    const { sections, fetchSections, showToast, fetchAllData } = useApp();
    const [localSections, setLocalSections] = useState([]);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        setLocalSections(sections);
    }, [sections]);

    const handleToggle = (id) => {
        setLocalSections(prev => prev.map(s =>
            s.id === id ? { ...s, enabled: !s.enabled } : s
        ));
    };

    const handleSave = async () => {
        setSaving(true);
        try {
            // Send the updated sections to backend
            await api.put('/sections', { sections: localSections });

            // IMPORTANT: Refetch ALL data to update the frontend state
            await fetchAllData();

            showToast('Section settings saved successfully! Refresh homepage to see changes.');

            // Optional: Also fetch sections specifically
            await fetchSections();

        } catch (error) {
            console.error('Error saving sections:', error);
            showToast('Error saving sections', 'error');
        } finally {
            setSaving(false);
        }
    };

    const handleReset = async () => {
        if (window.confirm('Reset sections to default?')) {
            setSaving(true);
            try {
                await api.post('/sections/reset');
                await fetchAllData();
                showToast('Sections reset to default');
            } catch (error) {
                showToast('Error resetting sections', 'error');
            } finally {
                setSaving(false);
            }
        }
    };

    if (!localSections.length) {
        return <div className="loader"><div className="loader-spinner"></div></div>;
    }

    return (
        <div style={{ background: '#fff', borderRadius: '8px', padding: '24px', boxShadow: '0 1px 6px rgba(0,0,0,.08)' }}>
            <h3>Manage Homepage Sections</h3>
            <p style={{ fontSize: '14px', color: '#666', marginBottom: '18px' }}>
                Toggle which sections are visible on the homepage. Changes take effect immediately after saving.
            </p>

            <div id="sections-list">
                {localSections.map(section => (
                    <div key={section.id} style={{ display: 'flex', alignItems: 'center', gap: '14px', padding: '13px 16px', border: '1.5px solid #eee', borderRadius: '6px', marginBottom: '8px', background: '#fafafa' }}>
                        <span style={{ fontSize: '22px' }}>{section.icon}</span>
                        <div style={{ flex: 1 }}>
                            <strong style={{ display: 'block', fontSize: '14px' }}>{section.label}</strong>
                            <span style={{ fontSize: '12px', color: '#888' }}>{section.desc}</span>
                        </div>
                        <label style={{ position: 'relative', width: '44px', height: '24px', flexShrink: 0 }}>
                            <input
                                type="checkbox"
                                checked={section.enabled}
                                onChange={() => handleToggle(section.id)}
                                style={{ opacity: 0, width: 0, height: 0, position: 'absolute' }}
                            />
                            <div style={{
                                position: 'absolute',
                                inset: 0,
                                background: section.enabled ? '#1a7431' : '#ccc',
                                borderRadius: '12px',
                                cursor: 'pointer',
                                transition: 'background .2s'
                            }}>
                                <div style={{
                                    position: 'absolute',
                                    width: '18px',
                                    height: '18px',
                                    background: '#fff',
                                    borderRadius: '50%',
                                    top: '3px',
                                    left: section.enabled ? '23px' : '3px',
                                    transition: 'transform .2s'
                                }}></div>
                            </div>
                        </label>
                    </div>
                ))}
            </div>

            <div style={{ display: 'flex', gap: '12px', marginTop: '16px' }}>
                <button className="btn btn-red" onClick={handleSave} disabled={saving}>
                    {saving ? 'Saving...' : 'Save Section Settings'}
                </button>
                <button className="btn btn-outline" onClick={handleReset} disabled={saving}>
                    Reset to Default
                </button>
            </div>

            <div style={{ marginTop: '16px', padding: '12px', background: '#f0f8ff', borderRadius: '6px', fontSize: '13px', color: '#0066cc' }}>
                💡 Tip: After saving, refresh the homepage to see the changes immediately.
            </div>
        </div>
    );
};

export default SectionsManager;